/* =============================================================
   AADHAV – TOURNAMENT EXPENSES SELECTORS (PRODUCTION READY)
============================================================= */

/**
 * 🔥 BASE STATE (SAFE ACCESS)
 */
export const selectTournamentExpensesState = (state) =>
  state?.admin?.tournamentExpenses ?? {};

/**
 * 🔥 EXPENSES LIST (ALWAYS ARRAY)
 */
export const selectTournamentExpenses = (state) => {
  const data = selectTournamentExpensesState(state).expenses;

  if (!Array.isArray(data)) {
    console.warn("⚠️ Expenses is not array:", data);
    return [];
  }

  return data;
};

/**
 * 🔥 LOADING STATE
 */
export const selectTournamentExpensesLoading = (state) =>
  Boolean(selectTournamentExpensesState(state).loading);

/**
 * 🔥 ERROR STATE
 */
export const selectTournamentExpensesError = (state) =>
  selectTournamentExpensesState(state).error ?? null;

/**
 * 🔥 META (SAFE DEFAULT)
 */
export const selectTournamentExpensesMeta = (state) => {
  const meta = selectTournamentExpensesState(state).meta;

  return {
    total: meta?.total ?? 0,
    total_pages: meta?.total_pages ?? 1,
    page: meta?.page ?? 1,
    limit: meta?.limit ?? 10,
  };
};

/**
 * 🔥 SELECTED EXPENSE
 */
export const selectSelectedTournamentExpense = (state) =>
  selectTournamentExpensesState(state).selectedExpense ?? null;

/**
 * 🔥 TOTAL EXPENSE AMOUNT
 */
export const selectTotalExpenseAmount = (state) => {
  const expenses = selectTournamentExpenses(state);

  return expenses.reduce(
    (total, expense) => total + Number(expense.amount || 0),
    0
  );
};

/**
 * 🔥 GROUP BY EXPENSE CATEGORY
 */
export const selectExpensesByCategory = (state) => {
  const expenses = selectTournamentExpenses(state);

  return expenses.reduce((acc, expense) => {
    const key = (
      expense.category_name ||
      expense.category ||
      "UNKNOWN"
    ).toUpperCase();

    if (!acc[key]) acc[key] = [];

    acc[key].push(expense);

    return acc;
  }, {});
};

/**
 * 🔥 GROUP BY TOURNAMENT
 */
export const selectExpensesByTournament = (state) => {
  const expenses = selectTournamentExpenses(state);

  return expenses.reduce((acc, expense) => {
    const key = expense.tournament_id || 0;

    if (!acc[key]) acc[key] = [];

    acc[key].push(expense);

    return acc;
  }, {});
};

/**
 * 🔥 EXPENSE COUNT
 */
export const selectTournamentExpenseCount = (state) =>
  selectTournamentExpenses(state).length;